<template>
  <header class="my-header" id="myHeader">
    <div class="header-wrap">
      <div class="each l" @click="goBack" v-show="!homePage">
        <span class="btn-back"></span>
      </div>
      <div class="each c">
        <h2 class="title">{{ showTitle }}</h2>
      </div>
      <div class="each r"></div>
    </div>
  </header>
</template>

<script setup>
import { storage, exitWindow } from "@/utils";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  pagePath: {
    type: String,
    required: true,
  },
});

const emitter = inject("emitter");

const router = useRouter();

let isApp = false;

const state = reactive({
  showTitle: "",
  homePage: false,
});

watch(
  () => props.title,
  (val) => {
    if (val) {
      state.showTitle = val;
    }
  },
  { immediate: true },
);

watch(
  () => props.pagePath,
  (val) => {
    if (val === "/" || val === "/meeting") {
      state.homePage = true;
    } else {
      state.homePage = false;
    }
  },
  { immediate: true },
);

const onSetHeaderTitle = async (title) => {
  state.showTitle = title;
};
onMounted(async () => {
  isApp = storage.get("sourceDevice");
  nextTick(() => {
    let height = document.getElementById("myHeader");
    let headerSet = storage.get("headerSet");
    if (!headerSet) {
      storage.set("headerSet", height.clientHeight);
    }
  });
  emitter.on("setHeaderTitle", onSetHeaderTitle);
});
onBeforeUnmount(async () => {
  emitter.off("setHeaderTitle", onSetHeaderTitle);
});

const goBack = () => {
  const { state } = window.history;
  if (state) {
    if (window.history.length === 1) {
      if (isApp) {
        exitWindow();
        return false;
      }
    } else {
      if (state.back) {
        router.go(-1);
        return false;
      }
    }
    // app外随便打开一个页面无返回页面直接返回到首页
    router.push("/");
  } else {
    exitWindow();
  }
};

const { showTitle, homePage } = toRefs(state);
</script>

<style lang="less" scoped>
@import "@/style/common.less";
.page-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  background: #f7f8fa;
}
.my-header {
  position: fixed;
  right: 0;
  left: 0;
  z-index: 999;
  color: #1b2a42;
  background: rgba(255, 255, 255, 1);
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
  top: 0;
  .header-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 44px;
    padding: 0 20px;
    .each {
      display: flex;
      align-items: center;
      justify-content: center;
      // height: 100%;
      &.l {
        width: 109px;
        display: flex;
        justify-content: flex-start;
        .btn-back {
          display: inline-block;
          width: 22px;
          height: 22px;
          background: url("https://susuanqiniu.knowbox.cn/fe/h5-tarc/icon-back-sign.png")
            center no-repeat;
          background-size: 100% 100%;
          &:active {
            opacity: 0.8;
          }
        }
      }
      &.c {
        .title {
          font-size: 18px;
          max-width: 225px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: 500;
        }
      }
      &.r {
        width: 109px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
